import { toPrecision } from './toPrecision.ts';

/** Returns value of percentage of (min - max) to the given precision (number of decimal places). */
export function percentageToValue(percentage: number, min: number, max: number, precision: int = 0): number {
  return toPrecision((percentage * (max - min)) + min, precision);
}